enum ExamsProceduresOrderByEnum {
  NAME = 'name',
  SEND_BY = 'sendBy',
  DATE = 'date',
}

export default ExamsProceduresOrderByEnum;
